import Accordion from '@/components/molecules/Accordion/index';
import React from 'react';
import { RideGrid } from '@rimac-seguros/ride-system-components';
import helpers from '@/utils/helpers';

import './styles.scss';

const SectionQuestions = ({
    title,
    questions,
}) => {

    const handleOpenQuestion = (open, question) => {
        if (open) {
            helpers.getTagAction(
                "Consulta SOAT",
                title,
                "Click",
                question.trim(),
                "trackAction"
            );
        }
    };

    const currentQuestions =questions;

    return (
        <div className="section-questions">
            <RideGrid>
                <div className="section-questions_head">
                    <h2 dangerouslySetInnerHTML={{ __html: title }} />
                </div>
                <div className="section-questions_content">
                    <div className="section-questions_content-group">
                        {currentQuestions?.map((_, i) => (
                        <Accordion
                            key={`question-${i}`}
                            icon={_.icon}
                            label={_.question}
                            onClick={(e) => handleOpenQuestion(e, _.question)}
                            lastItem={i === questions.length - 1}
                        >
                            <div
                            className="section-questions_content-accordion"
                            dangerouslySetInnerHTML={{ __html: _.answer }}
                            />
                        </Accordion>
                        ))}
                    </div>
                </div>
            </RideGrid>
        </div>
    )
};

export default SectionQuestions;